<app-base-overlay
  [title]="overlayTitle()"
  [description]="overlayDescription()"
  [showBackButton]="showBackButton()"
  (onBackClicked)="onBack()">
  @if (step() === 'name') {
    <form body class="flex flex-col gap-4" [signalForm]="nameForm">
      <lib-signal-text-field
        label="Name"
        placeholder="e.g. Contact us form"
        [formField]="nameForm.name" />
    </form>
  } @else if (step() === 'ai') {
    <div body class="flex flex-col gap-5">
      <div class="ai-composer-shell">
        <div class="ai-composer-inner relative flex flex-col gap-3 p-4">
          <div class="flex items-center gap-2.5">
            <span
              class="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-primary-600 text-white shadow-sm shadow-primary-600/25">
              <app-svg-icon src="assets/icons/creation.svg" [size]="16" />
            </span>
            <div class="min-w-0">
              <p class="text-sm font-semibold text-slate-950">Build with AI</p>
            </div>
          </div>
          <textarea
            rows="3"
            [ngModel]="prompt()"
            (ngModelChange)="prompt.set($event)"
            (keydown)="onPromptKeydown($event)"
            [disabled]="createState.loading()"
            placeholder="e.g. Create a contact form with name, email, phone and a message field..."
            class="w-full resize-none bg-transparent px-0.5 py-1 text-sm leading-6 text-slate-900 outline-none placeholder:text-slate-400 disabled:opacity-50"></textarea>

          <div class="flex justify-end">
            <lib-signal-button
              [fullWidth]="false"
              [loading]="createState.loading()"
              [disabled]="!canGenerate()"
              (clicked)="onGenerate()">
              Generate
            </lib-signal-button>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-3">
        <div class="h-px flex-1 bg-slate-200"></div>
        <p class="shrink-0 text-xs font-medium uppercase tracking-wide text-slate-400">
          or start another way
        </p>
        <div class="h-px flex-1 bg-slate-200"></div>
      </div>

      <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <button
          type="button"
          [disabled]="createState.loading()"
          (click)="onCreateFromScratch()"
          class="group flex cursor-pointer flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-left transition hover:border-slate-300 hover:bg-slate-50 hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-50">
          <span
            class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-100 text-slate-700 transition group-hover:bg-slate-200/80">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 5v14M5 12h14"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round" />
            </svg>
          </span>
          <span class="flex flex-col gap-1">
            <span class="text-sm font-semibold text-slate-950">Create from scratch</span>
            <span class="text-xs leading-5 text-slate-500">
              Start with a blank canvas and add fields yourself.
            </span>
          </span>
        </button>

        <button
          type="button"
          [disabled]="createState.loading()"
          (click)="goToTemplateStep()"
          class="group relative flex cursor-pointer flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-left transition hover:border-slate-300 hover:bg-slate-50 hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-50">
          <span
            class="absolute right-3 top-3 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-500">
            Soon
          </span>
          <span
            class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-100 text-slate-700 transition group-hover:bg-slate-200/80">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M4 5h7v7H4V5Zm9 0h7v7h-7V5ZM4 14h7v7H4v-7Zm9 0h7v7h-7v-7Z"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linejoin="round" />
            </svg>
          </span>
          <span class="flex flex-col gap-1 pr-10">
            <span class="text-sm font-semibold text-slate-950">Choose from template</span>
            <span class="text-xs leading-5 text-slate-500">
              Pick a ready-made layout for common form types.
            </span>
          </span>
        </button>
      </div>
    </div>
  } @else {
    <div body class="flex flex-col items-center gap-3 py-4 text-center">
      <p class="text-sm font-medium text-slate-900">Coming soon</p>
      <p class="max-w-sm text-sm leading-6 text-slate-500">
        We’re building a template gallery so you can start from common form
        layouts. For now, use AI or create from scratch.
      </p>
    </div>
  }

  @if (step() === 'name') {
    <div actions class="flex flex-wrap justify-end gap-3">
      <lib-signal-button
        appearance="outline"
        [fullWidth]="false"
        [disabled]="createState.loading()"
        (clicked)="close()">
        Cancel
      </lib-signal-button>
      <lib-signal-button
        [fullWidth]="false"
        [disabled]="!canContinueName()"
        (clicked)="goToAiStep()">
        Continue
      </lib-signal-button>
    </div>
  } @else if (step() === 'ai') {
    <div actions class="flex flex-wrap justify-end gap-3">
      <lib-signal-button
        appearance="outline"
        [fullWidth]="false"
        [disabled]="createState.loading()"
        (clicked)="close()">
        Cancel
      </lib-signal-button>
    </div>
  } @else {
    <div actions class="flex flex-wrap justify-end gap-3">
      <lib-signal-button
        appearance="outline"
        [fullWidth]="false"
        (clicked)="onBack()">
        Back
      </lib-signal-button>
    </div>
  }
</app-base-overlay>
